import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const ReviewButton = styled(Button)(({ theme }) => ({
  padding: 0,
  color: theme.palette.grey[600],
  textDecoration: 'underline',
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
  minWidth: 'auto',
}));

export default ReviewButton;
